import { Link } from "@remix-run/react";

import Logo from "~/components/logo/Logo";
import {
  CONTACT_CITY,
  CONTACT_EMAIL,
  CONTACT_PHONE,
  SOCIAL_LINKS,
} from "~/config/constants";
import { useConsent } from "~/context/ConsentContext";
import { COURSES } from "~/data/courses";
import { useLocalizedPath } from "~/helpers/navigationHelper";
import blog from "~/i18n/blog";
import common from "~/i18n/common";
import courses from "~/i18n/courses";
import { useT } from "~/i18n/useT";

import "./Footer.scss";

export default function Footer() {
  const t = useT(common);
  const c = useT(courses);
  const b = useT(blog);
  const localize = useLocalizedPath();
  const { openPreferences } = useConsent();

  return (
    <footer className="ss-footer">
      <div className="ss-footer__inner">
        <div className="ss-footer__top">
          <div className="ss-footer__brand">
            <Logo variant="dark" />
            <p className="ss-footer__tagline">{t.footer.tagline}</p>
            <ul className="ss-footer__socials">
              {SOCIAL_LINKS.map((social) => (
                <li key={social.url}>
                  <a
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ss-footer__social"
                    aria-label={t.footer.socialLabel(social.label)}
                  >
                    <span aria-hidden="true">{social.abbr}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <nav className="ss-footer__col" aria-labelledby="footer-courses">
            <h2 className="ss-footer__heading" id="footer-courses">
              {t.footer.coursesHeading}
            </h2>
            <ul className="ss-footer__list">
              {COURSES.map((course) => (
                <li key={course.slug}>
                  <Link
                    to={localize(`/course/${course.slug}`)}
                    className="ss-footer__link"
                  >
                    {c[course.slug].title}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="ss-footer__col">
            <h2 className="ss-footer__heading">{t.footer.contactHeading}</h2>
            <p className="ss-footer__tagline">{t.footer.contactBody}</p>

            <address className="ss-footer__address">
              <span>{CONTACT_CITY}</span>
              <a href={`tel:${CONTACT_PHONE.replace(/\s/g, "")}`}>
                {CONTACT_PHONE}
              </a>
              <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
            </address>
          </div>
        </div>

        <div className="ss-footer__bottom">
          <p className="ss-footer__copy">
            {t.footer.copyright(new Date().getFullYear())}
          </p>
          <nav className="ss-footer__legal">
            <Link to={localize("/blog")}>{b.navLabel}</Link>
            <Link to={localize("/terms")}>{t.footer.terms}</Link>
            <Link to={localize("/privacy")}>{t.footer.privacy}</Link>
            <Link to={localize("/imprint")}>{t.footer.imprint}</Link>
            {/* Art. 7(3) GDPR: withdrawing consent must be as easy as giving it. */}
            <button type="button" onClick={openPreferences}>
              {t.footer.cookieSettings}
            </button>
          </nav>
        </div>
      </div>
    </footer>
  );
}
